import React, { useState } from 'react';
import { Modal } from './Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-black/50 border-t border-cyan-500/10 py-8 px-4" data-id="element-20">
        <div className="max-w-4xl mx-auto" data-id="element-21">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-22">
            <p className="text-gray-400 text-sm" data-id="element-23">
              © 2024 Avatar Digital Rentable. Todos los derechos reservados.
            </p>
            <div className="flex gap-6" data-id="element-24">
              <button onClick={() => setShowPrivacy(true)} className="text-gray-400 hover:text-cyan-400 transition-colors text-sm" data-id="element-25">
                Privacy Policy
              </button>
              <button onClick={() => setShowTerms(true)} className="text-gray-400 hover:text-cyan-400 transition-colors text-sm" data-id="element-26">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Privacy Policy" data-id="element-27">
        <div className="prose prose-invert max-w-none" data-id="element-28">
          <p className="text-gray-300 mb-4" data-id="element-29">
            Última actualización: {new Date().toLocaleDateString('es-ES')}
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-30">
            1. Información que Recopilamos
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-31">
            Recopilamos información que nos proporcionas directamente cuando
            compras nuestro producto, incluyendo nombre, dirección de correo
            electrónico e información de pago.
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-32">
            2. Uso de la Información
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-33">
            Utilizamos la información recopilada para:
          </p>
          <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2" data-id="element-34">
            <li data-id="element-35">Procesar tus compras y entregarte el producto</li>
            <li data-id="element-36">Enviarte actualizaciones sobre tu pedido</li>
            <li data-id="element-37">Mejorar nuestros productos y servicios</li>
            <li data-id="element-38">Cumplir con obligaciones legales</li>
          </ul>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-39">
            3. Protección de Datos
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-40">
            Implementamos medidas de seguridad para proteger tu información
            personal. Utilizamos encriptación SSL y no almacenamos información
            de tarjetas de crédito en nuestros servidores.
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-41">
            4. Compartir Información
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-42">
            No vendemos ni compartimos tu información personal con terceros,
            excepto cuando sea necesario para procesar pagos o cumplir con la
            ley.
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-43">
            5. Tus Derechos
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-44">
            Tienes derecho a acceder, corregir o eliminar tu información
            personal en cualquier momento. Contáctanos para ejercer estos
            derechos.
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-45">6. Cookies</h3>
          <p className="text-gray-300 mb-4" data-id="element-46">
            Utilizamos cookies esenciales para el funcionamiento del sitio. No
            utilizamos cookies de seguimiento de terceros.
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-47">
            7. Cambios a esta Política
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-48">
            Podemos actualizar esta política ocasionalmente. Te notificaremos
            sobre cambios significativos por correo electrónico.
          </p>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Terms of Service" data-id="element-49">
        <div className="prose prose-invert max-w-none" data-id="element-50">
          <p className="text-gray-300 mb-4" data-id="element-51">
            Última actualización: {new Date().toLocaleDateString('es-ES')}
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-52">
            1. Aceptación de Términos
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-53">
            Al comprar y usar Avatar Digital Rentable, aceptas estos términos de
            servicio. Si no estás de acuerdo, no uses el producto.
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-54">
            2. Descripción del Producto
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-55">
            Avatar Digital Rentable es un kit digital que incluye:
          </p>
          <ul className="list-disc list-inside text-gray-300 mb-4 space-y-2" data-id="element-56">
            <li data-id="element-57">Ebook con plan de 7 días</li>
            <li data-id="element-58">Plantillas de identidad, estilo y scripts</li>
            <li data-id="element-59">Checklist anti-cringe</li>
            <li data-id="element-60">Pack de ganchos</li>
            <li data-id="element-61">Calendario de 14 días</li>
          </ul>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-62">
            3. Licencia de Uso
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-63">
            Se te otorga una licencia personal, no transferible para usar el
            producto. No puedes revender, redistribuir o compartir el contenido.
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-64">
            4. Garantía
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-65">
            Si aplicas el plan durante 7 días y no obtienes un avatar definido,
            10 guiones listos y escenas repetibles, el problema no era el avatar
            sino la falta de sistema. Este producto proporciona el sistema, no
            garantiza resultados automáticos.
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-66">
            5. Reembolsos
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-67">
            Dado que es un producto digital entregado inmediatamente, no
            ofrecemos reembolsos después de la compra. Asegúrate de leer la
            descripción completa antes de comprar.
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-68">
            6. Propiedad Intelectual
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-69">
            Todo el contenido del producto está protegido por derechos de autor.
            No puedes reproducir, modificar o crear trabajos derivados sin
            permiso explícito.
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-70">
            7. Limitación de Responsabilidad
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-71">
            No somos responsables de los resultados obtenidos al usar el
            producto. Los resultados dependen de tu implementación y esfuerzo.
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-72">
            8. Modificaciones
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-73">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. Los cambios entrarán en vigor inmediatamente después de su
            publicación.
          </p>

          <h3 className="text-xl font-bold text-white mt-6 mb-3" data-id="element-74">
            9. Ley Aplicable
          </h3>
          <p className="text-gray-300 mb-4" data-id="element-75">
            Estos términos se rigen por las leyes de Estados Unidos. Cualquier
            disputa se resolverá en los tribunales correspondientes.
          </p>
        </div>
      </Modal>
    </>;
}